/* eslint-disable */
export const ERROR_CHANGE_SUCCESS = 'ERROR_CHANGE_SUCCESS';

export const errorChange = () => ({
  type: ERROR_CHANGE_SUCCESS,
});
